import { ENTITY_REQUEST_FORMS_CRUD_ACTION_CREATORS } from '../actions/entity_request_forms_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

// Approver-configured request forms, available to buyers and internal service teams alike.
const entityRequestFormsRestCrudThunksForBuyer = new RestCrudThunks(
	'entity_request_forms',
	'entity_request_form',
	'entityRequestForm',
	'entityRequestForms',
	ENTITY_REQUEST_FORMS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER
);

const entityRequestFormsRestCrudThunksForSupplier = new RestCrudThunks(
	'entity_request_forms',
	'entity_request_form',
	'entityRequestForm',
	'entityRequestForms',
	ENTITY_REQUEST_FORMS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER
);

export const entityRequestFormsRestCrudThunks = (userType) =>
	userType === ROLE_TYPES.SUPPLIER
		? entityRequestFormsRestCrudThunksForSupplier
		: entityRequestFormsRestCrudThunksForBuyer;

const JSON_HEADERS = { Accept: 'application/json', 'Content-Type': 'application/json' };

// The single active form for the caller's company + entity type. Resolves to `null` when
// no form is configured (backend returns { data: null }).
export const fetchActiveEntityRequestForm = (userType) => (entityType) => (dispatch) => {
	const apiUrl = `/api/v1/${userType}/entity_request_forms/active/${entityType}`;
	return new Promise((resolve, reject) => {
		fetchUtils
			.get(BASE_URL + apiUrl, { headers: JSON_HEADERS })
			.then(parseJSON)
			.then(({ json, status }) => {
				const response = json;
				if (status === 401) {
					dispatch(logoutSuccess());
				}
				if (response.status === 'error') {
					reject(response.message);
				} else {
					resolve(response.data);
				}
			})
			.catch((error) => {
				reject(error.message);
			});
	});
};
